/// <reference path="../classes/CompositionResult.ts" />
/// <reference path="../classes/composition.ts" />

module App.Interfaces {
    export interface ICompositionService {
        getFormInformation(): ng.IPromise<string>;
        handleCompositionRequest(key: string, action: object): ng.IPromise<App.Classes.ICompositionResult>;
        doCompositionRequest(postComposition: Classes.IComposition): ng.IPromise<App.Classes.ICompositionResult>;
        getReplacementVehicleTexts (settlementId: string): ng.IPromise<string>;
    }
}